module.exports = __webpack_public_path__ + "img/logo_teachertool_v2_square.14e5f2b6.png";